<template>
  <TabelaOSD
    :colunas="resolvedColumns"
    :linhas="table.rows"
    :carregando="table.isLoading"
    :total-linhas="table.totalRows"
    :pagina="pagination.page"
    :campo-ordenacao="pagination.sort"
    :ordem-ordenacao="pagination.order"
    :texto-tabela-vazia="$t('indicadoresNaoEncontrados')"
    @page-change="onPageChange"
    @sort-change="onSortChange"
    @reload="getDashboard"
  >
    <template #toolbar-actions>
      <VisionOneExport v-bind="pagination" :headers="headers" />
    </template>
    <template #toolbar-filters>
      <VisionOneFilters :loading="table.isLoading" @filter="onFilter" />
    </template>
    <template #cell-id="props">
      <span>
        <a
          class="btn btn-success mx-1"
          @click="downloadPdf(props.linha.id, props.linha.codigo)"
        >
          <i class="bi bi-filetype-pdf" />
        </a>
      </span>
    </template>
  </TabelaOSD>
  <DownloadPdfModal ref="downloadPdfModal" v-bind="pdfProps" />
</template>

<script>
import VisionOneExport from './VisionOneExport.vue';
import VisionOneFilters from './VisionOneFilters.vue';
import TabelaOSD from '@/modules/shared/components/tabelaOSD/TabelaOSD.vue';
import { getPaginatedVisionOneData } from '../visionOneService';
import { useToast } from 'vue-toastification';
import { toDate, toMoney, toPhone } from '@/modules/core/utils/formats';
import { i18n } from '@/modules/localization';
import { ref, computed } from 'vue';
import DownloadPdfModal from '../../../shared/components/DownloadPdfModal.vue';
export default {
  components: { VisionOneExport, VisionOneFilters, TabelaOSD, DownloadPdfModal },
  data: () => ({
    pdfProps: {
      params: {
        ID: '',
        nomeRelatorio: 'os/Main',
      },
      nomeArquivo: '',
    },
    table: {
      totalRows: 0,
      rows: [],
      columns: ref([
        {
          field: 'id',
          tdClass: 'text-center',
          globalSearchDisabled: true,
          sortable: false,
        },
        {
          label: computed((_) => i18n.global.t('codigo')),
          field: 'codigo',
        }, {
          label: computed((_) => i18n.global.t('dataHoraCriacao')),
          field: 'dataHoraServico',
          tdClass: 'text-break',
          formatFn: toDate,
        }, {
          label: computed((_) => i18n.global.t('status')),
          field: 'status',
        }, {
          label: computed((_) => i18n.global.t('tipo')),
          field: 'tipoOs',
          formatFn: (value) => {
            const options = ['Orçamento', 'Ordem de serviço'];
            return options[value];
          },
        }, {
          label: computed((_) => i18n.global.t('nomeCliente')),
          field: 'nomeCliente',
        }, {
          label: computed((_) => i18n.global.t('foneCliente')),
          field: 'foneCliente',
          formatFn: toPhone,
        }, {
          label: computed((_) => i18n.global.t('dataHoraEncerramento')),
          field: 'dataHoraEncerramento',
          tdClass: 'text-break',
          formatFn: toDate,
        }, {
          label: computed((_) => i18n.global.t('valorTotal')),
          field: 'valorTotal',
          tdClass: 'text-end',
          formatFn: toMoney,
        }, {
          label: computed((_) => i18n.global.t('valorServicos')),
          field: 'valorServicos',
          tdClass: 'text-end',
          formatFn: toMoney,
        }, {
          label: computed((_) => i18n.global.t('valorProdutos')),
          field: 'valorProdutos',
          tdClass: 'text-end',
          formatFn: toMoney,
        }, {
          label: computed((_) => i18n.global.t('valorDescontoTotal')),
          field: 'valorTotalDesconto',
          tdClass: 'text-end',
          formatFn: toMoney,
        },
        {
          label: computed((_) => i18n.global.t('valorPago')),
          field: 'valorPago',
          tdClass: 'text-end',
          formatFn: toMoney,
        }, {
          label: computed((_) => i18n.global.t('usuario')),
          field: 'usuarioNome',
        },

      ]),
      mode: 'remote',
      class: 'osd-table',
      styleClass: 'vgt-table bordered condensed',
      compactMode: true,
      lineNumbers: true,
      paginationOptions: {
        enabled: true,
        mode: 'pages',
        perPageDropdownEnabled: false,
        nextLabel: '>',
        prevLabel: '<',
        infoFn: (params) => `
          ${params.firstRecordOnPage} - ${params.lastRecordOnPage} de ${params.totalRecords}
        `,
      },
      sortOptions: {
        enabled: true,
        initialSortBy: { field: 'dataHoraServico', type: 'desc' },
      },
      isLoading: false,
    },
    pagination: {
      page: 1,
      sort: 'dataHoraServico',
      order: 'desc',
      search: '',
    },
  }),
  computed: {
    resolvedColumns() {
      return this.table.columns.map((column) => ({
        ...column,
        label: column.label?.value ?? column.label,
      }));
    },
    headers() { return this.resolvedColumns.map((column) => column.label ?? ''); },
  },
  methods: {
    updateParams(pagination) {
      this.pagination = { ...this.pagination, ...pagination };
    },
    onPageChange(page) {
      this.updateParams({ page });
      this.getDashboard();
    },
    onSortChange(field) {
      const nextOrder = this.pagination.sort === field && this.pagination.order === 'asc' ? 'desc' : 'asc';
      this.updateParams({
        page: 1,
        sort: field,
        order: nextOrder,
      });
      this.getDashboard();
    },
    onFilter(filters) {
      this.updateParams({ ...filters, page: 1 });
      this.getDashboard();
    },
    async getDashboard() {
      this.table.isLoading = true;
      try {
        const data = await getPaginatedVisionOneData(this.pagination);
        this.table.rows = data.dados;
        this.table.totalRows = data.total;
      } catch (error) {
        useToast().error(this.$t('erroAoObterDashboard'));
      }
      this.table.isLoading = false;
    },
    downloadPdf(id, codigo) {
      this.pdfProps.params.ID = id;
      this.pdfProps.nomeArquivo = 'OS-' + codigo;
      this.$refs.downloadPdfModal.show();
    },
  },
};
</script>
